import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { graphql } from 'react-apollo';
import { compose, mapProps } from 'recompose';
import Questions from 'components/threepp/assessment/Questions/Questions';
import { getDDEDetailsForTemplate, getTemplateDDEActions } from 'graphql/operations';
import TemplateFooter from 'components/threepp/assessment/Footer/TemplateFooter';
import { useTranslation } from 'react-i18next';
import { NETWORK_ONLY } from 'graphql/fetchPolicies';
import LoadingPage from 'components/common/Loader/Spinner/Spinner';
import { getTemplateActions, isFetchingTemplateActions } from './selector';

const useStyles = makeStyles(() => ({
  loader: {
    height: '100vh',
    textAlign: 'center'
  }
}));

export const DdeWrapper = props => {
  const classes = useStyles();
  const { template, actions, isLoading, templateLanguages } = props;

  const { t: translate } = useTranslation();

  const [uploadAttachmentProgressCount, updateuploadAttachmentProgressCount] = React.useState(0);

  const incrementAttachmentUploadCount = () => {
    updateuploadAttachmentProgressCount(uploadAttachmentProgressCount + 1);
  };

  const decrementAttachmentUploadCount = () => {
    updateuploadAttachmentProgressCount(uploadAttachmentProgressCount - 1);
  };

  if (isLoading) {
    return (
      <div className={classes.loader}>
        <LoadingPage size="md" />
      </div>
    );
  }

  return (
    <div>
      <Questions
        assessment={template}
        incrementAttachmentUploadCount={incrementAttachmentUploadCount}
        decrementAttachmentUploadCount={decrementAttachmentUploadCount}
        isNewRecord
        actions={actions}
      />
      <TemplateFooter
        actions={actions}
        template={template}
        templateLanguages={templateLanguages}
        t={translate}
        attachmentUploadCount={uploadAttachmentProgressCount}
      />
    </div>
  );
};
export const DdeHOC = compose(
  graphql(getDDEDetailsForTemplate, {
    options: props => ({
      variables: {
        templateId: props.template.id,
        recordId: props.template.recordId
      },
      fetchPolicy: NETWORK_ONLY
    }),
    name: 'getDDEDetailsForTemplate'
  }),
  graphql(getTemplateDDEActions, {
    options: props => ({
      variables: {
        templateId: props.template.id,
        recordId: props.template.recordId
      },
      fetchPolicy: NETWORK_ONLY
    }),
    name: 'getTemplateDDEActions'
  }),
  mapProps(props => {
    const actions = getTemplateActions(props);
    const { templateLanguages } = props;
    return {
      template: props.template,
      templateLanguages,
      actions,
      incrementAttachmentUploadCount: props.incrementAttachmentUploadCount,
      decrementAttachmentUploadCount: props.decrementAttachmentUploadCount,
      isNewRecord: props.isNewRecord,
      isLoading: isFetchingTemplateActions(props)
    };
  })
);

export default DdeHOC(DdeWrapper);
